function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "chat_comment"
}, /*#__PURE__*/React.createElement("path", {
  d: "m12 2c-5.514 0-10 4.486-10 10 0 1.841.499 3.622 1.449 5.185l-1.378 3.444c-.148.371-.061.795.222 1.078.191.191.447.293.707.293.125 0 .251-.023.371-.071l3.444-1.378c1.563.95 3.344 1.449 5.185 1.449 5.514 0 10-4.486 10-10s-4.486-10-10-10zm0 18c-1.618 0-3.179-.482-4.512-1.395-.168-.115-.366-.175-.564-.175-.126 0-.252.023-.371.071l-1.758.703.703-1.758c.124-.31.085-.66-.104-.936-.912-1.331-1.394-2.892-1.394-4.51 0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z"
}));

var Svg026Chat = function Svg026Chat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg026Chat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/026-chat.650913a6.svg";
export { ForwardRef as ReactComponent };